var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutComponent,_vm._b({tag:"component"},'component',_vm.layoutProps,false),[_c('template',{slot:"field"},[_c('vue-tel-input',{class:_vm.errorClasses,attrs:{"input-id":_vm.field.attribute,"placeholder":_vm.inputPlaceholder,"disabled":_vm.isDisabled,"preferred-countries":[
        'be',
        'nl',
        'fr',
        'gb',
        'ie',
        'us',
        'de',
        'es',
        'it' ],"input-options":{ showDialCode: true },"valid-characters-only":true,"input-classes":"form-control"},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }